import { faFacebookF } from "@fortawesome/free-brands-svg-icons/faFacebookF"
import { faPhone } from "@jewlr/pro-solid-svg-icons/faPhone"
import {
  Box,
  Flex,
  FontAwesomeIcon,
  Typography,
  Image,
} from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React, { useEffect } from "react"
import { Link, withRouter } from "react-router-dom"
import styled from "styled-components"

import withHeader from "areas/header/hoc/with-header"

import Flashbar from "./flashbar"
import HeaderDropdowns from "./header-dropdowns"
import Search from "./search/search"

// three columns evenly split
// content will be aligned based on the column position (left, center, end)

const HeaderColumn = styled(Flex).attrs((props) => ({
  style: {
    flex: props.sticky ? "0 1 auto" : "1",
    flexDirection: props.sticky ? "row" : "column-reverse",
  },
}))``

const DesktopHeader = ({ location, sticky, toggleMenu }) => {
  useEffect(() => {
    toggleMenu(true)
  }, [location.pathname])

  return (
    <Box containWide pad py="12px">
      <Flex justifyContent="space-between">
        <HeaderColumn style={{ display: sticky ? "none" : "block" }}>
          <Flex>
            <a
              href={"https://www.facebook.com/jewlrcom"}
              rel="noopener noreferrer"
              target="_blank"
            >
              <FontAwesomeIcon
                color="primary"
                fontSize="12px"
                icon={faFacebookF}
                width="10px"
              />
              {/*temporary hardcoded*/}
              <Typography as="span" bold fontSize="12px" pl="4px" pt="2px">
                1.6M +
              </Typography>
            </a>
            <Box pl="20px">
              <a href={`tel:+${sl.config.customer_service_toll_free}`}>
                <FontAwesomeIcon
                  color="primary"
                  flip="horizontal"
                  fontSize="12px"
                  icon={faPhone}
                  width="12px"
                />
                <Typography as="span" bold fontSize="12px" pl="4px" pt="2px">
                  {sl.config.customer_service_toll_free}
                </Typography>
              </a>
            </Box>
          </Flex>
          <Flex>
            <Flashbar />
          </Flex>
        </HeaderColumn>
        <HeaderColumn>
          <Flex
            mb={1}
            style={{ justifyContent: sticky ? "flex-start" : "center" }}
          >
            <Box as={Link} data-lc="home" display="block" to="/">
              <Image
                alt="Jewlr"
                height={sticky ? "24px" : "35px"}
                lazyload={false}
                ratio="300 / 66"
                src={require("images/layout/logo/black/JEWLR_LOGO_US.svg")}
              />
            </Box>
          </Flex>
        </HeaderColumn>
        <HeaderColumn
          alignItems="flex-end"
          gap={sticky ? "4px" : "12px"}
          justifyContent="flex-end"
          sticky={sticky}
        >
          <Flex
            id="searchToggle"
            justifyContent={sticky ? "center" : "flex-end"}
            position="relative"
          >
            <HeaderDropdowns />
          </Flex>
          <Flex
            alignItems="center"
            id="searchHeader"
            position="relative"
            {...(sticky
              ? {
                  ml: "10px",
                }
              : {
                  justifyContent: "flex-end",
                  mt: "5px",
                })}
          >
            <Search sticky={sticky} />
          </Flex>
        </HeaderColumn>
      </Flex>
    </Box>
  )
}

DesktopHeader.propTypes = {
  location: PropTypes.object,
  sticky: PropTypes.bool,
  toggleMenu: PropTypes.func,
}

export default withHeader(withRouter(DesktopHeader))
